import { Routes, Route } from 'react-router-dom';
import LandingPage from './components/Landing/LandingPage';
import LoginPage from './components/Auth/LoginPage';
import SignupPage from './components/Auth/SignupPage';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/Layout/AppLayout';
import ArticlesPage from './components/Articles/ArticlesPage';
import ArticleView from './components/Articles/ArticleView';
import DecksPage from './components/Decks/DecksPage';
import DeckDetail from './components/Decks/DeckDetail';
import FlashcardReview from './components/Review/FlashcardReview';
import StatsPage from './components/Stats/StatsPage';
import PricingPage from './components/Pricing/PricingPage';
import ManageSubscription from './components/Pricing/ManageSubscription';
import DashboardPage from './components/Dashboard/DashboardPage';
import AdminPage from './components/Admin/AdminPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="articles/:id" element={<ArticleView />} />
        <Route path="decks" element={<DecksPage />} />
        <Route path="decks/:id" element={<DeckDetail />} />
        <Route path="decks/:id/review" element={<FlashcardReview />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="subscription" element={<ManageSubscription />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}

export default App;
